import { Inject, Optional, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseLoopBackApiService } from '../base.service';
import { LOCAL_STORAGE_VARIABLES, STAFF_TYPE } from '../../../../shared/constants';

@Injectable()
export class SettingLoopBackApiService extends BaseLoopBackApiService {

  modelName = 'Settings';
}



// WEBPACK FOOTER //
// ./src/app/services/api/loopback/custom/setting.service.ts